const orgchart = {
    "organization": {
        "departments": [
            {
                "name": "CDN",
                "managerName": "Aziel Gibson",
                "employees": [
                    {
                        "name": "John",
                        "department": "CDN",
                        "salary": 80,
                        "office": "Lisbon",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Aziel Gibson",
                        "department": "CDN",
                        "salary": 145,
                        "office": "New York",
                        "isManager": true,
                        "skills": [
                            "Caching",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Carl Nava",
                        "department": "CDN",
                        "salary": 230,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Korbyn Cuevas",
                        "department": "CDN",
                        "salary": 86,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Cameron Doyle",
                        "department": "CDN",
                        "salary": 81,
                        "office": "Lisbon",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "CSS",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Armando Trujillo",
                        "department": "CDN",
                        "salary": 178,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "CSS",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Franco Short",
                        "department": "CDN",
                        "salary": 82,
                        "office": "Lisbon",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "CSS",
                            "AI"
                        ]
                    },
                    {
                        "name": "Cohen Dougherty",
                        "department": "CDN",
                        "salary": 157,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "CSS",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Luca Acosta",
                        "department": "CDN",
                        "salary": 175,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "CSS",
                            "AI"
                        ]
                    },
                    {
                        "name": "Salem Foley",
                        "department": "CDN",
                        "salary": 290,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "CSS",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Edison Hamilton",
                        "department": "CDN",
                        "salary": 267,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "CSS",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Korbin Francis",
                        "department": "CDN",
                        "salary": 108,
                        "office": "Lisbon",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Niko Molina",
                        "department": "CDN",
                        "salary": 229,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Thomas Nixon",
                        "department": "CDN",
                        "salary": 201,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Zahir Hartman",
                        "department": "CDN",
                        "salary": 106,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Levi Rivers",
                        "department": "CDN",
                        "salary": 141,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Elias Quintero",
                        "department": "CDN",
                        "salary": 215,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Ander Quintero",
                        "department": "CDN",
                        "salary": 226,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Adan Sanford",
                        "department": "CDN",
                        "salary": 280,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Performance",
                            "AI"
                        ]
                    },
                    {
                        "name": "Matthew Christensen",
                        "department": "CDN",
                        "salary": 204,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "C++",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Banks Fitzpatrick",
                        "department": "CDN",
                        "salary": 250,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Jayceon Murillo",
                        "department": "CDN",
                        "salary": 128,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "AI"
                        ]
                    },
                    {
                        "name": "Devin Weber",
                        "department": "CDN",
                        "salary": 285,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Performance",
                            "GoLang"
                        ]
                    }
                ]
            },
            {
                "name": "Developer Platform",
                "managerName": "Belen Norman",
                "employees": [
                    {
                        "name": "Jill",
                        "department": "Developer Platform",
                        "salary": 100,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Belen Norman",
                        "department": "Developer Platform",
                        "salary": 252,
                        "office": "London",
                        "isManager": true,
                        "skills": [
                            "HTML",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Melanie Esparza",
                        "department": "Developer Platform",
                        "salary": 231,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Remi Hendrix",
                        "department": "Developer Platform",
                        "salary": 162,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "CSS",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Adaline Murphy",
                        "department": "Developer Platform",
                        "salary": 238,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Isabela Casey",
                        "department": "Developer Platform",
                        "salary": 283,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Iris Frye",
                        "department": "Developer Platform",
                        "salary": 212,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Remy Wang",
                        "department": "Developer Platform",
                        "salary": 94,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Gwen Gutierrez",
                        "department": "Developer Platform",
                        "salary": 259,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "C++",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Rosie Hull",
                        "department": "Developer Platform",
                        "salary": 227,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Aubrielle Collier",
                        "department": "Developer Platform",
                        "salary": 225,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Selena Hutchinson",
                        "department": "Developer Platform",
                        "salary": 263,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Jazmine Holt",
                        "department": "Developer Platform",
                        "salary": 139,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Janelle Hall",
                        "department": "Developer Platform",
                        "salary": 158,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Maia Blackburn",
                        "department": "Developer Platform",
                        "salary": 294,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Laurel Moore",
                        "department": "Developer Platform",
                        "salary": 194,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Dylan Evans",
                        "department": "Developer Platform",
                        "salary": 90,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Zara Bradford",
                        "department": "Developer Platform",
                        "salary": 163,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Paisleigh Sherman",
                        "department": "Developer Platform",
                        "salary": 118,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Fiona Robinson",
                        "department": "Developer Platform",
                        "salary": 300,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Violeta Cortes",
                        "department": "Developer Platform",
                        "salary": 98,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Mya Hardy",
                        "department": "Developer Platform",
                        "salary": 127,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Elsie McCarthy",
                        "department": "Developer Platform",
                        "salary": 128,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "AI"
                        ]
                    }
                ]
            },
            {
                "name": "Accounting",
                "managerName": "Audrey Leblanc",
                "employees": [
                    {
                        "name": "Audrey Leblanc",
                        "department": "Accounting",
                        "salary": 154,
                        "office": "Singapore",
                        "isManager": true,
                        "skills": [
                            "HTML",
                            "CSS",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Eden Roy",
                        "department": "Accounting",
                        "salary": 190,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Scout Hansen",
                        "department": "Accounting",
                        "salary": 259,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Adele Castillo",
                        "department": "Accounting",
                        "salary": 237,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Annalise Fuller",
                        "department": "Accounting",
                        "salary": 172,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Danielle Adkins",
                        "department": "Accounting",
                        "salary": 89,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Cheyenne Fowler",
                        "department": "Accounting",
                        "salary": 150,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Alisson Russell",
                        "department": "Accounting",
                        "salary": 214,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Kaia Wyatt",
                        "department": "Accounting",
                        "salary": 112,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Zaylee Blair",
                        "department": "Accounting",
                        "salary": 136,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Mackenzie Gill",
                        "department": "Accounting",
                        "salary": 101,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "Rust",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Daniella Noble",
                        "department": "Accounting",
                        "salary": 289,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Alexandria Booth",
                        "department": "Accounting",
                        "salary": 156,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Deborah Taylor",
                        "department": "Accounting",
                        "salary": 186,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Kennedi Palacios",
                        "department": "Accounting",
                        "salary": 300,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "Performance",
                            "AI"
                        ]
                    },
                    {
                        "name": "Kiana Ray",
                        "department": "Accounting",
                        "salary": 104,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "C++",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Keyla Hurst",
                        "department": "Accounting",
                        "salary": 137,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Keyla Bravo",
                        "department": "Accounting",
                        "salary": 242,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Performance",
                            "AI"
                        ]
                    },
                    {
                        "name": "Emerald Macdonald",
                        "department": "Accounting",
                        "salary": 228,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Carmen McLaughlin",
                        "department": "Accounting",
                        "salary": 221,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Annabella Velasquez",
                        "department": "Accounting",
                        "salary": 172,
                        "office": "San Francisco",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Mikaela Hampton",
                        "department": "Accounting",
                        "salary": 89,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "C++",
                            "GoLang"
                        ]
                    }
                ]
            },
            {
                "name": "Bots",
                "managerName": "Braden McMahon",
                "employees": [
                    {
                        "name": "Braden McMahon",
                        "department": "Bots",
                        "salary": 219,
                        "office": "San Francisco",
                        "isManager": true,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Marcelo Sullivan",
                        "department": "Bots",
                        "salary": 241,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "CSS",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Charlie West",
                        "department": "Bots",
                        "salary": 131,
                        "office": "Lisbon",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Kai Rojas",
                        "department": "Bots",
                        "salary": 102,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Andre Spears",
                        "department": "Bots",
                        "salary": 106,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Kylo Hayes",
                        "department": "Bots",
                        "salary": 213,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Performance",
                            "AI"
                        ]
                    },
                    {
                        "name": "Kameron Colon",
                        "department": "Bots",
                        "salary": 149,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Weston McIntosh",
                        "department": "Bots",
                        "salary": 130,
                        "office": "Lisbon",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Sam Hubbard",
                        "department": "Bots",
                        "salary": 87,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "Performance",
                            "AI"
                        ]
                    },
                    {
                        "name": "Troy Bartlett",
                        "department": "Bots",
                        "salary": 103,
                        "office": "Lisbon",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Matthias Greene",
                        "department": "Bots",
                        "salary": 288,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Performance",
                            "AI"
                        ]
                    },
                    {
                        "name": "Idris Kent",
                        "department": "Bots",
                        "salary": 297,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "C++",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Chaim Cisneros",
                        "department": "Bots",
                        "salary": 80,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Rust",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Jackson Parsons",
                        "department": "Bots",
                        "salary": 150,
                        "office": "New York",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "AI"
                        ]
                    },
                    {
                        "name": "Thaddeus Dillon",
                        "department": "Bots",
                        "salary": 172,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Arlo Person",
                        "department": "Bots",
                        "salary": 203,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Neil Carroll",
                        "department": "Bots",
                        "salary": 188,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "Performance",
                            "Postgres"
                        ]
                    },
                    {
                        "name": "Genesis Felix",
                        "department": "Bots",
                        "salary": 187,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "C++",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Hugh Bowman",
                        "department": "Bots",
                        "salary": 139,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "Caching",
                            "Rust",
                            "AI"
                        ]
                    },
                    {
                        "name": "Ibrahim Gould",
                        "department": "Bots",
                        "salary": 262,
                        "office": "Austin",
                        "isManager": false,
                        "skills": [
                            "HTML",
                            "Performance",
                            "GoLang"
                        ]
                    },
                    {
                        "name": "Sullivan Nunez",
                        "department": "Bots",
                        "salary": 165,
                        "office": "London",
                        "isManager": false,
                        "skills": [
                            "Distributed Systems",
                            "C++",
                            "AI"
                        ]
                    },
                    {
                        "name": "Hank Sandoval",
                        "department": "Bots",
                        "salary": 165,
                        "office": "Singapore",
                        "isManager": false,
                        "skills": [
                            "Typescript",
                            "Rust",
                            "Postgres"
                        ]
                    }
                ]
            }
        ]
    }
}

export default orgchart